import updateLocoScroll from 'locomotive-scroll'

function setupFaqAccordion() {
  const $body = $('body');

  $body.on('click', '.c-accordion-btn', function(e) {
    const $accordionRow = $(this).closest('.c-accordion-row');
    const $accordionPanel = $accordionRow.find('.c-accordion-panel');

    // Close all other panels
    $('.section-faq .c-accordion-panel').each(function(index, element) {
      if (element !== $accordionPanel[0]) {
        $(element).slideUp();
      }
    });

    $('.c-accordion-row').removeClass('is-active');

    // Toggle the clicked panel
    if ($accordionPanel.css('display') === 'block') {
      $accordionPanel.slideUp(400);
    } else {
      $accordionPanel.slideDown(400);
      $accordionRow.addClass('is-active');
    }

    setTimeout(() => {
      updateLocoScroll();
    }, 500);
  });
}

setupFaqAccordion();
